import styled from 'styled-components'
import { theme } from '~/styles'

export const ContainerModalError = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;

  & svg {
    color: ${theme.colors.colorFFB324};
    margin-left: auto;
    margin-right: auto;
    width: 132px;
    height: 132px;
  }
`
export const TitleError = styled.h2`
  font: normal normal bold 20px/24px Inter;
  color: ${props => props.theme.colors.color2d3139};
  text-align: center;
`
export const ParagraphError = styled.p`
  font: normal normal normal 14px/17px Inter;
  color: ${props => props.theme.colors.color6b7786};
  text-align: center;
  margin: 14px 0 34px 0;
  white-space: pre-wrap;
`
export const ContainerButton = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  button {
    width: 116px;
    height: 40px;
  }
`
